import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const FullPageLoader = ({ show = true }) => (
  <Backdrop sx={{ color: '#fff', zIndex: 99999 }} open={show}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default FullPageLoader;
